import React from "react";

const AboutCard = ({ icon, title, disc }) => {
  return (
    <div className="w-full flex flex-col items-center p-2 group border duration-300 shadow-xl hover:shadow-none hover:border-[#7decc6] rounded-xl">
      <div>
        <img
          src={icon}
          alt="icon"
          className="p-4 h-14 w-14 bg-blue-gray-400 group-hover:bg-[#7decc6] rounded-full duration-300 group-hover:rounded-2xl bg-opacity-35"
        />
      </div>
      <div>
        <p className="text-xl mb-0 py-3 text-black font-bold">{title}</p>
      </div>
      <div>
        <p className="text-center text-gray-700 text-base font-medium">{disc}</p>
      </div>
    </div>
  );
};

export default AboutCard;
